define.alias("shared/components/shared/ui/social-profile-switcher/linkinbio/item", "calendar/components/shared/ui/social-profile-switcher/linkinbio/item");